import styled from "@emotion/styled";

const Name = styled("h1")(() => ({
  margin: 0,
  color: "#fff",
  fontFamily: "Oswald",
  fontSize: "3rem",
  textTransform: "uppercase",
}));

export default Name;
